import { Field } from '../dashboards/primitives/Field';
import { fieldStyle } from '../dashboards/primitives/field-style';
import { SimpleModal } from '../shared/SimpleModal';

import { useGiftPassComp } from './use-gift-pass-comp';

export function GiftPassCompModal({ onClose }: { onClose: () => void }) {
  const { values, errors, submitError, submitting, set, submit } = useGiftPassComp();

  return (
    <SimpleModal
      open
      onClose={() => {
        if (!submitting) onClose();
      }}
      title="Create comp pass"
    >
      <form
        onSubmit={submit}
        noValidate
        style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
      >
        <p style={{ margin: 0, fontSize: 13 }}>
          One free pass, good for one workshop seat. Its code is emailed to this address.
        </p>
        <Field label="Purchaser email" required error={errors.purchaserEmail}>
          <input
            type="email"
            value={values.purchaserEmail}
            onChange={(e) => set('purchaserEmail')(e.target.value)}
            style={fieldStyle(errors.purchaserEmail ? 'error' : undefined)}
          />
        </Field>
        <Field label="Reason" required error={errors.reason}>
          <textarea
            value={values.reason}
            rows={3}
            onChange={(e) => set('reason')(e.target.value)}
            style={fieldStyle(errors.reason ? 'error' : undefined, {
              height: 'auto',
              padding: '8px 10px',
            })}
          />
        </Field>
        {submitError && (
          <p role="alert" style={{ margin: 0, fontSize: 12.5, color: 'var(--nb-risk)' }}>
            {submitError}
          </p>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            type="button"
            className="nb-btn nb-btn-ghost"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button type="submit" className="nb-btn nb-btn-primary" disabled={submitting}>
            {submitting ? 'Creating…' : 'Create comp pass'}
          </button>
        </div>
      </form>
    </SimpleModal>
  );
}
